import { render, staticRenderFns } from "./BioData.vue?vue&type=template&id=6a79fea2&scoped=true"
import script from "./BioData.vue?vue&type=script&lang=js"
export * from "./BioData.vue?vue&type=script&lang=js"
import style0 from "./BioData.vue?vue&type=style&index=0&id=6a79fea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a79fea2",
  null
  
)

export default component.exports